import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AccountAttributesEnum } from './../../../enums/account-attributes.enum';
import { Component, Inject, OnInit } from '@angular/core';
import { sumBy } from 'lodash-es';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { OauthProvider } from '../../../../oauth/providers';
import { RequestBodyService } from '../../../services/request-body.service';
import { CommonUtilService } from '../../../services/CommonUtil.service';
import { SalesforceService } from '../../../services/crm/salesforce.service';
import { ReConnectSettingComponent } from '../../re-connect-setting/re-connect-setting.component';
import { ToastrService } from 'ngx-toastr';
import { ContactinboxService } from '../../../../results/inboxintel/contacts/services/contactinbox.service';
import { InboxintelService } from '../../../../results/inboxintel/services/inboxintel.service';
import { ContactsService } from '../../../../results/contacts/services/contacts.service';
import { RoDs } from '../../../services/rods.service';
import { SalesForceAccountListComponent } from './sales-force-account-list/sales-force-account-list.component';
import {
  FilterPipeModule,
  OrderByPipeModule,
} from '../../../pipes';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { OfflineExportsApiService, SalesforceApiService } from '../../../services/api';
import {
  OfflineExportsCrmExportRequestDto,
  SalesforceCampaignDto,
  SalesforceGeneralSettingsDto,
  SalesforceLeadownersDto,
} from '../../../dto';
import { switchMap, take } from 'rxjs/operators';
import { FeatureFlagService, LoadingService, SocketExportService } from '../../../services';
import { FeatureFlagsEnum, OfflineExportsCrmExportTypesEnum, OfflineExportsExportTypesEnum } from '../../../enums';
import { environment } from '../../../../../environments/environment';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { UserService } from '../../../../core/services/user.service';
import { getErrorMessage, isSilentHttpStatus } from 'src/app/shared/helpers';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SiModalModule } from '../../si-modal';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  DuplicateResolutionRadioGroupModule
} from '../../ui-components/duplicate-resolution-group/duplicate-resolution-radio-group.module';
import {
  SalesForceAccountMappingPipe,
  SalesForceAccountMappingPipeModule,
} from '../../../pipes/sales-force-account-mapping';

export class FailedContactModel {
    matchId: string;
    contactName: string;
    companyName: string;
    errorMessage: string;
}

enum PageTypes {
    LOADING = "loading",
    EXPORT_TYPE = "exportType",
    LEAD_OWNER = "leadOwner",
    ACCOUNT_MAPPING = "accountMapping",
    CAMPAIGN = "campaign",
    DUPLICATES = "duplicates",
    DUPLICATES_ASYNC = "duplicatesAsync",
    JOB_TITLE = "jobTitle",
    EXPORT = "export",
    EXPORT_FINISHED = "exportFinished",
    EXPORT_EMPTY = "exportEmpty",
    EXPORT_FAILED = "exportFailed",
    REQUIRES_REAUTH = "requiresReauth"
}

const LOADING_TAG_ASYNC_EXPORT: string = 'LOADING_TAG_ASYNC_EXPORT';

@UntilDestroy()
@Component({
    selector: 'app-salesforce',
    templateUrl: './salesforce.component.html',
    styleUrls: ['./../export.component.scss'],
    imports: [CommonModule, FormsModule, SiModalModule,
      MatProgressSpinnerModule, MatFormFieldModule,
      MatCheckbox, MatExpansionModule,
      MatCheckbox, MatExpansionModule, FontAwesomeModule,
      MatTooltipModule, MatButtonModule, FilterPipeModule,
      OrderByPipeModule, SalesForceAccountMappingPipeModule, MatInputModule,
      DuplicateResolutionRadioGroupModule, ReactiveFormsModule
    ],
    providers: [SalesForceAccountMappingPipe],
    standalone: true
})

export class SalesforceComponent implements OnInit {
    readonly isLoading$: Observable<boolean> = this.loadingService.getIsLoading(LOADING_TAG_ASYNC_EXPORT);
    readonly pagesConfig = [
        { type: PageTypes.LOADING },
        { type: PageTypes.EXPORT_TYPE },
        { type: PageTypes.LEAD_OWNER },
        { type: PageTypes.ACCOUNT_MAPPING },
        { type: PageTypes.CAMPAIGN },
        { type: PageTypes.DUPLICATES },
        { type: PageTypes.JOB_TITLE },
        { type: PageTypes.EXPORT },
        { type: PageTypes.EXPORT_FINISHED },
        { type: PageTypes.EXPORT_EMPTY },
        { type: PageTypes.EXPORT_FAILED },
        { type: PageTypes.REQUIRES_REAUTH }
    ];
    pages = [...this.pagesConfig];
    leadOwners: SalesforceLeadownersDto[];
    campaigns: SalesforceCampaignDto[];
    exportType: 'contact' | 'lead';
    generalSettings: SalesforceGeneralSettingsDto;
    showPreviousButton = false;
    showNextButton = false;
    currentPageIndex: number = this.getPageIndex(PageTypes.LOADING);
    initialPageIndex: number = this.getPageIndex(PageTypes.LOADING);
    selectedLeadOwner;
    selectedCampaignIds: string[] = [];
    contacts = [];
    icpIntelJobUUID: string = null;
    duplicateLeadsMatchIds = {};
    duplicateContactsMatchIds = [];
    duplicateLeadsCount = 0;
    duplicateContactsCount = 0;
    duplicateMatchIds;
    duplicateCount = 0;
    duplicateResolution = 'update';
    exportedContactCount = 0;
    busyLabel = 'Loading ...';
    busySublabel = '';
    isBusy = false;
    showCloseButton = false;
    showCancelButton = true;
    showRetryButton = false;
    failedContacts: FailedContactModel[] = [];
    failedAccounts: FailedContactModel[] = [];
    duplicateFailedContacts: FailedContactModel[] = [];
    contactFailureCounts;
    exportError = '';
    filterLeadOwner = '';
    filterCampaigns = '';
    filterAccountMapping = '';
    exportFrom;
    humanverified = [];
    machineverified = [];
    unmatchedContacts = [];
    inboxIntelmatchId = [];
    isExportButton = false;
    isSFLoggedin = false;
    isSalesforceComponentOpened: boolean = true;
    isSelectedAll: boolean;
    isLoadingAccountMapping = true;
    accuracyTier: Array<'HV' | 'EV' | 'MV'> | null;
    accuracyTierText: string;
    jobTitleControl: FormControl = new FormControl();
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
    readonly pageTypes: typeof PageTypes = PageTypes;

    private readonly asyncInitialData: {
        request_type: OfflineExportsExportTypesEnum;
        totalCount: number;
        requestBody: any;
    };

    constructor(
        public commonUtilService: CommonUtilService,
        private salesforceService: SalesforceService,
        private authenticationService: AuthenticationService,
        private requestBodyService: RequestBodyService,
        private userService: UserService,
        private contactInboxService: ContactinboxService,
        private toastr: ToastrService,
        private inboxintelService: InboxintelService,
        private contactService: ContactsService,
        private rodsService: RoDs,
        private salesForceAccountMappingPipe: SalesForceAccountMappingPipe,
        private readonly matDialog: MatDialog,
        private readonly salesforceApiService: SalesforceApiService,
        private readonly featureFlagService: FeatureFlagService,
        private readonly offlineExportsApiService: OfflineExportsApiService,
        private readonly loadingService: LoadingService,
        private readonly matDialogRef: MatDialogRef<SalesforceComponent>,
        private readonly socketExportService: SocketExportService,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) {
        if (this.data.requestBody) {
            this.asyncInitialData = { ...this.data };
        }

        this.accuracyTier = this.commonUtilService.getSelectedAccuracyTier(
            this.data.contacts,
            this.data.requestBody
        );
        this.accuracyTierText = this.commonUtilService.getAccuracyTierExportText(this.accuracyTier);

        this.icpIntelJobUUID = this.data['icpIntelJobUUID'] || null;

        if (this.data['contacts']) {
            this.contacts = this.data['contacts'];
            this.exportFrom = this.data['isExportKey'];
            const matchedContacts = [];
            this.contacts.map((item) => {
                if (item && item.inboxIntelContactId) {
                    matchedContacts.push(item.inboxIntelContactId);
                }
            });

            if (this.exportFrom === 'fromInboxIntel' || this.data['fromExport'] === 'fromInboxIntel') {
                this.isExportButton = true;
                this.inboxIntelmatchId = this.contacts;
                this.exportFrom === 'fromInboxIntel';
                //this.contacts = this.contacts.map(item => item.searchResult);
                this.contacts = this.contacts.map((contact) => {
                    return {
                        name: contact.name || (contact.searchResult && contact.searchResult.firstName + ' ' + contact.searchResult && contact.searchResult.lastName) || '',
                        matchId: (contact.searchResult && contact.searchResult.matchId) || '',
                        companyName: (contact.searchResult && contact.searchResult.companyName) || '',
                        verified: (contact.searchResult && contact.searchResult.verified) || null,
                        jobTitle: (contact.searchResult && contact.searchResult.jobTitle) || '',
                        primaryDomain: (contact.searchResult && contact.searchResult.primaryDomain) || contact.domain || '',
                        inboxIntelContactId: contact.inboxIntelContactId
                    }
                });
                this.humanverified = this.contacts.filter((item) => item.verified === true);
                this.machineverified = this.contacts.filter((item) => {
                    return item.verified === false;
                });
                this.unmatchedContacts = this.contacts.filter((item) => {
                    return item.verified === undefined || item.verified === null;
                });
            }
            if (this.salesforceService.isReconnect || this.salesforceService.isFromInboxIntel) {
                this.exportFrom = 'fromInboxIntel';
                this.inboxIntelmatchId = this.data['contacts'];
                this.isExportButton = false;
                this.exportInboxintel();
                this.salesforceService.isReconnect = false;
            }

        }
    }

    ngOnInit(): void {
        this.initializeComponent();
    }

    initializeFirstStep() {
        this.currentPageIndex = this.getPageIndex(PageTypes.LOADING);
        this.initialPageIndex = this.currentPageIndex;
        this.salesforceApiService.validateMapping().pipe(untilDestroyed(this)).subscribe((mappingData) => {
            if (Object.values(mappingData).every(item => item === true)) {
                this.getSettings();
            } else {
                const sectionsInError = [];
                if (!mappingData.leadFields) {
                    sectionsInError.push('Lead Mappings');
                }
                if (!mappingData.contactFields) {
                    sectionsInError.push('Contact Mappings');
                }
                if (!mappingData.accountFields) {
                    sectionsInError.push('Company Mappings');
                }
                if (this.userService.hasAccess(AccountAttributesEnum.TECHEXPORTS)) {
                    if (!mappingData.technoLeadFields) {
                        sectionsInError.push('Technographics Mappings');
                    }
                    if (!mappingData.technoContactFields) {
                        sectionsInError.push('Technographics Mappings');
                    }
                    if (!mappingData.technoAccountFields) {
                        sectionsInError.push('Technographics Mappings');
                    }
                }
                const uniqueSections = Array.from(new Set(sectionsInError));
                uniqueSections.forEach(section => {
                    this.commonUtilService.showToastWithError(
                        `One or more fields in your ${section} are no longer available. Update your ${section}.`
                    );
                });
                this.matDialogRef.close();
            }
        }, error => {
            if (this.tryRefreshTokenOnAuthError(error, () => this.initializeFirstStep())) {
                return;
            }

            if (this.shouldShowErrorToast(error)) {
                this.commonUtilService.showToastWithError(getErrorMessage(error));
            }
            this.onClose();
        });
    }

    private errorRefreshToken() {
        if (this.isSalesforceComponentOpened) {
            this.onClose();
            const modalConfig: MatDialogConfig = {
                panelClass: 'modal-lg',
                data: {
                    provider: OauthProvider.Salesforce,
                }
            };
            if (this.data['contacts']) {
                if (this.exportFrom === 'fromInboxIntel') {
                    modalConfig.data['match_ids'] = this.inboxIntelmatchId;
                    modalConfig.data['ifFromList'] = 'fromInboxIntel';
                } else {
                    modalConfig.data['match_ids'] = this.contacts;
                }
            }
            this.matDialog.open(ReConnectSettingComponent, modalConfig);
        }
    }

    private getSettings() {
        this.salesforceApiService.getSettings().pipe(untilDestroyed(this)).subscribe((response) => {
            this.generalSettings = response.general;
            this.loadLeadOwners();
        }, error => {
            if (error.status === 404 && error.error?.message) {
                if (this.shouldShowErrorToast(error)) {
                    this.commonUtilService.showToastWithError(getErrorMessage(error));
                }
                this.onClose();
                return;
            }
            if (this.tryRefreshTokenOnAuthError(error, () => this.initializeComponent())) {
                return;
            }

            if (this.shouldShowErrorToast(error)) {
                this.commonUtilService.showToastWithError(getErrorMessage(error));
            }
            this.onClose();
        });
    }

    private initializeComponent(): void {
        if (this.isExportButton === false && this.exportFrom !== 'fromInboxIntel') {
            this.initializeFirstStep();
        }
    }

    private loadLeadOwners() {
        this.salesforceApiService.getLeadOwners().pipe(untilDestroyed(this)).subscribe((response: SalesforceLeadownersDto[]) => {
            const userEmail: string = this.authenticationService.getEmailAndName('sfEmail', 'sfDisplayName')['email'].toLowerCase();
            this.leadOwners = response;
            this.leadOwners.forEach((element: SalesforceLeadownersDto) => {
                if (element.email === userEmail) {
                    if (this.generalSettings.sfDefaultOwnerIsConnectedUser === true) {
                        this.selectedLeadOwner = element.id;
                    }
                }
            });
            if (this.generalSettings.sfPromptForCampaigns) {
                this.loadCampaigns();
            } else {
                //check contact and account mapping enabled from salesforce settings
                if (this.generalSettings.sfAllowExportAsContact && this.generalSettings.sfAccountMapping) {
                    this.getSalesForceAccounts();
                }
                this.updatePageSequence();
            }
        }, (error) => {
            if (this.tryRefreshTokenOnAuthError(error, () => this.initializeFirstStep())) {
                return;
            }

            if (this.shouldShowErrorToast(error)) {
                this.commonUtilService.showToastWithError(getErrorMessage(error));
            }
            this.onClose();
        });
    }

    private loadCampaigns() {
        this.salesforceApiService.getCampaigns().pipe(untilDestroyed(this)).subscribe((response: SalesforceCampaignDto[]) => {
            this.campaigns = response;
            //check contact and account mapping enabled from salesforce settings
            if (this.generalSettings.sfAllowExportAsContact && this.generalSettings.sfAccountMapping) {
                this.getSalesForceAccounts();
            }
            this.updatePageSequence();
        }, (error) => {
            if (this.tryRefreshTokenOnAuthError(error, () => this.initializeFirstStep())) {
                return;
            }

            // Campaigns are optional: for 308 (silent), 400/403 (permissions), continue without campaigns.
            if ([308, 400, 403].includes(error?.status)) {
                if (this.shouldShowErrorToast(error)) {
                    this.commonUtilService.showToastWithError(getErrorMessage(error));
                }
                this.generalSettings = { ...this.generalSettings, sfPromptForCampaigns: false };
                this.campaigns = [];
                //check contact and account mapping enabled from salesforce settings
                if (this.generalSettings.sfAllowExportAsContact && this.generalSettings.sfAccountMapping) {
                    this.getSalesForceAccounts();
                }
                this.updatePageSequence();
                return;
            }

            if (this.shouldShowErrorToast(error)) {
                this.commonUtilService.showToastWithError(getErrorMessage(error));
            }
            this.onClose();
        });
    }

    private tryRefreshTokenOnAuthError(error: any, onRefreshSuccess: () => void): boolean {
        const invalidGrant: boolean = error?.status === 400 && error?.error?.errors?.[0]?.code === 'invalid_grant';
        const invalidSession: boolean = this.isInvalidSalesforceSession(error);
        if (!(error?.status === 401 || invalidGrant || invalidSession)) {
            return false;
        }

        this.salesforceService.isFromInboxIntel = false;
        this.salesforceApiService.refreshToken().pipe(untilDestroyed(this)).subscribe({
            next: () => onRefreshSuccess(),
            error: () => this.errorRefreshToken(),
        });
        return true;
    }

    /**
     * Some Salesforce auth failures come back as 403 (not 401) from our backend,
     * while the response body still indicates a session/auth issue.
     */
    private isInvalidSalesforceSession(error: any): boolean {
        if (![401, 403].includes(error?.status)) {
            return false;
        }

        const body: any = error?.error;
        const errorCode: string | undefined = body?.errorCode || body?.code;
        if (errorCode === 'INVALID_SESSION_ID') {
            return true;
        }

        // Fall back to string matching for cases where backend wraps/serializes the error.
        const bodyText: string =
            typeof body === 'string'
                ? body.toLowerCase()
                : (() => {
                      try {
                          return JSON.stringify(body).toLowerCase();
                      } catch {
                          return '';
                      }
                  })();

        return bodyText.includes('invalid_session_id') || bodyText.includes('session expired');
    }

    private shouldShowErrorToast(error: unknown): boolean {
        return !isSilentHttpStatus(error, 308);
    }

    private updatePageSequence(): void {
        this.featureFlagService.getFlag(FeatureFlagsEnum.SalesforceIntegrationsForLargeExports).pipe(take(1)).subscribe((isSalesforceFeatureEnabled: boolean) => {
            if (this.generalSettings.sfAllowExportAsContact === true) {
                this.exportType = 'contact';
            }

            if (this.generalSettings.sfAllowExportAsLead === true) {
                this.exportType = 'lead';
            }

            this.pages = this.pagesConfig.filter((currentPage: { type: PageTypes }) => {
                const isAsync: boolean = isSalesforceFeatureEnabled && (this.asyncInitialData?.totalCount || this.contacts?.length) > environment.salesforceMaxCount;
                const c1: boolean = currentPage.type === PageTypes.EXPORT_TYPE && (this.generalSettings.sfAllowExportAsLead === false || this.generalSettings.sfAllowExportAsContact === false);
                const c2: boolean = currentPage.type === PageTypes.JOB_TITLE && !isAsync;
                const c3: boolean = currentPage.type === PageTypes.CAMPAIGN && this.generalSettings.sfPromptForCampaigns === false;
                const c4: boolean = currentPage.type === PageTypes.LEAD_OWNER && this.generalSettings.sfPromptForLeadOwners === false;
                const c5: boolean = currentPage.type === PageTypes.ACCOUNT_MAPPING && !(this.generalSettings.sfAllowExportAsContact == true && this.generalSettings.sfAccountMapping == true);

                if (currentPage.type === PageTypes.DUPLICATES && isAsync) {
                    currentPage.type = PageTypes.DUPLICATES_ASYNC;
                    const isPrompt: boolean = this.generalSettings.sfDuplicateResolution === 'prompt';
                    if (!isPrompt) {
                        this.duplicateResolution = this.generalSettings.sfDuplicateResolution;
                    }
                    return isPrompt;
                }

                return !(c1 || c2 || c3 || c4 || c5);
            });

            this.next();
        });
    }

    next() {
        this.currentPageIndex++;
        if (this.currentPageIndex === this.getPageIndex(PageTypes.CAMPAIGN)) {
            this.filterCampaigns = '';
        }
        if (this.currentPageIndex == this.getPageIndex(PageTypes.ACCOUNT_MAPPING)) {
            if (!(this.generalSettings.sfAllowExportAsContact == true && this.generalSettings.sfAccountMapping == true && this.exportType == "contact")) {
                this.currentPageIndex++;
            }
        }
        this.executeCurrentStep();
    }

    previous() {
        let page = this.currentPageIndex;
        page = page - 1;
        if (this.currentPageIndex === this.getPageIndex(PageTypes.EXPORT_EMPTY)) {
            const duplicatesIndex: number = this.getPageIndex(PageTypes.DUPLICATES);
            if (this.generalSettings.sfDuplicateResolution !== 'prompt') {
                page = duplicatesIndex - 1;
            } else {
                page = duplicatesIndex;
            }
        }

        if (page === this.getPageIndex(PageTypes.DUPLICATES_ASYNC) && this.generalSettings.sfDuplicateResolution !== 'prompt') {
            page--;
        }

        if (page == this.getPageIndex(PageTypes.ACCOUNT_MAPPING)) {
            if (!(this.generalSettings.sfAllowExportAsContact == true && this.generalSettings.sfAccountMapping == true && this.exportType == "contact")) {
                page--;
            }
        }
        this.currentPageIndex = page;
        this.executeCurrentStep();
    }

    onClose() {
        this.isSalesforceComponentOpened = false;
        this.matDialogRef.close();
    }

    setExportType(type: 'contact' | 'lead'): void {
        this.exportType = type;
        this.next();
    }

    executeCurrentStep() {
        if (this.currentPageIndex === this.getPageIndex(PageTypes.DUPLICATES)) {
            this.showCloseButton = false;
            this.showNextButton = true;
            this.showPreviousButton = (this.currentPageIndex - 1) !== 0;
            this.validateDuplicates();
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.DUPLICATES_ASYNC)
            || this.currentPageIndex === this.getPageIndex(PageTypes.JOB_TITLE)) {
            this.showPreviousButton = (this.currentPageIndex - 1) !== 0;
            this.showNextButton = true;
            this.showCloseButton = false;
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.EXPORT)) {
            this.showCloseButton = false;
            this.showPreviousButton = false;
            this.showNextButton = false;
            const isV2: boolean = this.generalSettings.sfAllowExportAsContact && this.generalSettings.sfAccountMapping && this.exportType === 'contact';
            this.export(isV2);
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.EXPORT_EMPTY)) {
            if ((parseInt(`${this.getPageIndex(PageTypes.DUPLICATES)}`, 10) - 1) !== 0 && (parseInt(`${this.getPageIndex(PageTypes.DUPLICATES)}`, 10) - 1) !== undefined) {
                this.showPreviousButton = true;
            } else {
                this.showPreviousButton = false;
                this.showCancelButton = false;
            }
            this.showCloseButton = true;
            this.showNextButton = false;
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.LEAD_OWNER) || this.currentPageIndex === this.getPageIndex(PageTypes.CAMPAIGN) || this.currentPageIndex === this.getPageIndex(PageTypes.ACCOUNT_MAPPING)) {
            this.showPreviousButton = (this.currentPageIndex - 1) !== 0;
            this.showNextButton = true;
            this.showCloseButton = false;
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.EXPORT_FINISHED)) { // Last Page
            this.showNextButton = false;
            this.showPreviousButton = false;
            this.showCancelButton = false;
            this.showCloseButton = true;
        } else if (this.currentPageIndex === this.getPageIndex(PageTypes.EXPORT_TYPE)) { // First Page
            this.showPreviousButton = false;
            this.showCloseButton = false;
            this.showNextButton = false;
        }
    }

    selectLeadOwner(id) {
        if (this.selectedLeadOwner === id) {
            this.selectedLeadOwner = null;
        } else {
            this.selectedLeadOwner = id;
        }
    }

    selectCampaign(id: string): void {
        const idx: number = this.selectedCampaignIds.indexOf(id);
        if (idx === -1) {
            this.selectedCampaignIds.push(id);
        } else {
            this.selectedCampaignIds.splice(idx, 1);
        }
    }

    exportInboxintel() {
        const matchIds = [];
        const mvContacts = [];
        const unmatchedContacts = [];
        this.isExportButton = false;
        this.currentPageIndex = this.getPageIndex(PageTypes.LOADING);
        this.initialPageIndex = this.currentPageIndex;
        this.inboxIntelmatchId.map((contact) => {
            if (typeof contact === 'object' && contact['searchResult']) {
                if (typeof contact === 'object' && contact['searchResult'].matchId && contact['searchResult'].verified) {
                    matchIds.push(contact['searchResult'].matchId);
                } else if (typeof contact === 'object' && contact['searchResult'].matchId && !contact['searchResult'].verified) {
                    mvContacts.push(contact['searchResult'].matchId);
                } else {
                    unmatchedContacts.push(contact.inboxIntelContactId);
                }
            } else {
                if (typeof contact === 'object' && contact.matchId && contact.verified) {
                    matchIds.push(contact.matchId);
                } else if (typeof contact === 'object' && contact.matchId && !contact.verified) {
                    mvContacts.push(contact.matchId);
                } else {
                    unmatchedContacts.push(contact.inboxIntelContactId);
                }
            }

        });
        if (this.authenticationService.hasEmail('sfEmail')) {
            this.isSFLoggedin = true;
        }
        if (this.isSFLoggedin) {
            this.salesforceService.isFromInboxIntel = false;
            if (mvContacts.length > 0 || unmatchedContacts.length > 0) {
                if (this.commonUtilService.hasRODCreditsRemaining) {
                    this.requestVerification(mvContacts, unmatchedContacts);
                }
            }
            if (matchIds.length > 0) {
                this.initializeFirstStep();
            }
        } else {
            if (!this.isSFLoggedin && ((mvContacts.length > 0 && matchIds.length === 0) || (unmatchedContacts.length > 0 && matchIds.length === 0))) {
                if (this.commonUtilService.hasRODCreditsRemaining) {
                    this.requestVerification(mvContacts, unmatchedContacts);
                }
            } else {
                this.commonUtilService.openOauthCRM(OauthProvider.Salesforce, this.inboxIntelmatchId, 'fromInboxIntel');
                this.onClose();
            }
        }

    }

    validateDuplicates() {
        this.busyLabel = 'Validating Duplicates ...';
        this.busySublabel = 'Exporting your data, this will take just a minute...';
        this.isBusy = true;
        let matchIds = [];
        if (this.exportFrom === 'fromInboxIntel') {
            this.inboxIntelmatchId.map((contact) => {
                if (typeof contact === 'object' && contact['searchResult']) {
                    if (typeof contact === 'object' && contact['searchResult'].matchId && contact['searchResult'].verified) {
                        matchIds.push(contact['searchResult'].matchId);
                    }
                } else {
                    if (typeof contact === 'object' && contact.matchId && contact.verified) {
                        matchIds.push(contact.matchId);
                    }
                }

            });
        } else {
            matchIds = this.contacts.map((contact) => {
                if (typeof contact === 'object') {
                    return contact.matchId;
                } else {
                    return contact;
                }
            });
        }
        const requestBody = {
          exportType: this.exportType || 'Contact',
          ids: matchIds,
          icpIntelJobUUID: this.icpIntelJobUUID
        }
        this.salesforceApiService.validateDuplicates(requestBody).pipe(untilDestroyed(this)).subscribe((response) => {
            const dupes = [];
            let dupesCount = 0;
            const dupeLeads = [];
            const dupeContacts = [];
            let dupeLeadsCount = 0;
            let dupeContactsCount = 0;
            if ('leads' in response) {
                response.leads.forEach((item) => {
                    if (item['duplicate'] === true) {
                        dupesCount++;
                        dupeLeads.push(item);
                        dupes.push(item);
                    }
                });
                dupeLeadsCount = dupeLeads.length;
            }
            if ('contacts' in response) {
                response.contacts.forEach((item) => {
                    if (item['duplicate'] === true) {
                        dupesCount++;
                        dupeContacts.push(item);
                        dupes.push(item);
                    }
                });
                dupeContactsCount = dupeContacts.length;
            }
            this.duplicateLeadsCount = dupeLeadsCount;
            this.duplicateContactsCount = dupeContactsCount;
            this.duplicateLeadsMatchIds = dupeLeads;
            this.duplicateContactsMatchIds = dupeContacts;
            this.duplicateMatchIds = dupes;
            this.duplicateCount = dupesCount;
            if (dupesCount === 0) {
                this.next();
            } else {
                if (this.generalSettings.sfDuplicateResolution !== 'prompt') {
                    this.duplicateResolution = this.generalSettings.sfDuplicateResolution;
                    this.showPreviousButton = false;
                    this.showNextButton = false;
                    this.next();
                } else {
                    this.isBusy = false;
                    this.showNextButton = true;
                    if (this.getPageIndex(PageTypes.DUPLICATES) - 1 !== 0) {
                        this.showPreviousButton = true;
                    }
                }
            }
        }, (error) => {
            if (error.status === 403) {
                if (this.shouldShowErrorToast(error)) {
                    this.commonUtilService.showToastWithError(getErrorMessage(error));
                }
                this.onClose();
            }
        });
    }

    getByMatchId(id, name) {
        let Name;
        if (this.contacts.filter((item) => item.matchId === id).length > 0) {
            Name = this.contacts.filter((item) => item.matchId === id)[0][name];
        } else {
            Name = '';
        }
        return Name;
    }

    private export(v2?: boolean): void {
        if ((this.asyncInitialData?.totalCount || this.contacts?.length) >= environment.salesforceMaxCount) {
            this.exportAsync();
            return;
        }
        if (v2) {
            this.exportSyncV2();
            return;
        }
        this.exportSync();
    }

    private exportAsync(): void {
        const crmType: OfflineExportsCrmExportTypesEnum = OfflineExportsCrmExportTypesEnum.SALESFORCE;
        const request_type: OfflineExportsExportTypesEnum = this.getRequestType();
        const job = this.commonUtilService.convertMatchIdsToRequest(this.asyncInitialData?.requestBody, this.contacts, { request_type });
        const body: OfflineExportsCrmExportRequestDto = {
            export_options: {
                export_settings: {
                    duplicate_resolution: this.duplicateResolution,
                },
                crm_export_options: {
                    salesforce_export_options: {
                        campaign_ids: this.selectedCampaignIds,
                        ...(this.selectedLeadOwner ? { lead_owner: this.selectedLeadOwner } : {}),
                    },
                },
            },
            job: {
                ...job,
                label: this.jobTitleControl.value || this.commonUtilService.getFileNameByRequestType(crmType),
                icpintel_job_uuid: this.icpIntelJobUUID,
                request_type,
            },
        };

        this.exportCrm(crmType, body).pipe(untilDestroyed(this)).subscribe({
            next: () => {
                this.showCloseButton = true;
                this.showCancelButton = false;
            },
            error: () => this.onExportFailed()
        });
    }

    private getRequestType(): OfflineExportsExportTypesEnum {
        switch (this.exportType) {
            case 'lead':
                return OfflineExportsExportTypesEnum.LEADS;
            case 'contact':
                return OfflineExportsExportTypesEnum.CONTACTS;
        }
    }

    private exportCrm(crmType: OfflineExportsCrmExportTypesEnum, body: OfflineExportsCrmExportRequestDto) {
        return this.loadingService.loadingWrapper(this.offlineExportsApiService.exportCrm(crmType, body), LOADING_TAG_ASYNC_EXPORT);
    }

    private exportSync() {
        let toBeExported = [];
        const mvContacts = [];
        const unmatchedContacts = [];
        if (this.exportFrom === 'fromInboxIntel') {
            this.inboxIntelmatchId.map((contact) => {
                if (typeof contact === 'object' && contact['searchResult']) {
                    if (typeof contact === 'object' && contact['searchResult'].matchId && contact['searchResult'].verified) {
                        toBeExported.push(contact['searchResult'].matchId);
                    } else if (typeof contact === 'object' && contact['searchResult'].matchId && !contact['searchResult'].verified) {
                        mvContacts.push(contact['searchResult'].matchId);
                    } else {
                        unmatchedContacts.push(contact.inboxIntelContactId);
                    }
                } else {
                    if (typeof contact === 'object' && contact.matchId && contact.verified) {
                        toBeExported.push(contact.matchId);
                    } else if (typeof contact === 'object' && contact.matchId && !contact.verified) {
                        mvContacts.push(contact.matchId);
                    } else {
                        unmatchedContacts.push(contact.inboxIntelContactId);
                    }
                }
            });
        } else {
            toBeExported = this.contacts.map((contact) => {
                if (typeof contact === 'object') {
                    return contact.matchId;
                } else {
                    return contact;
                }
            });
        }
        // Skip all duplicates
        if (this.duplicateResolution === 'skip') {
            if (typeof this.duplicateMatchIds === 'object') {
                for (const key in this.duplicateLeadsMatchIds) {
                    if (this.duplicateLeadsMatchIds.hasOwnProperty(key)) {
                        this.commonUtilService.removeMatchId(toBeExported, this.duplicateLeadsMatchIds[key]);
                    }
                }
                for (const key in this.duplicateContactsMatchIds) {
                    if (this.duplicateContactsMatchIds.hasOwnProperty(key)) {
                        this.commonUtilService.removeMatchId(toBeExported, this.duplicateContactsMatchIds[key]);
                    }
                }
            } else {
                this.duplicateMatchIds.forEach((item) => {
                    this.commonUtilService.removeMatchId(toBeExported, item.key);
                });
            }
        }
        if (toBeExported.length === 0) {
            this.isBusy = false;
            this.currentPageIndex = this.getPageIndex(PageTypes.EXPORT_EMPTY);
            this.executeCurrentStep();
            return;
        }
        this.busyLabel = '';
        this.busySublabel = 'Exporting your data, this will take just a minute...';
        this.isBusy = true;
        this.exportedContactCount = toBeExported.length;
        this.exportV1(this.exportType, this.selectedLeadOwner, this.selectedCampaignIds, this.duplicateResolution, toBeExported, this.icpIntelJobUUID).pipe(untilDestroyed(this)).subscribe((failedContactsArray) => {
            if (this.exportFrom === 'fromInboxIntel') {
                const inboxIntelContactIds = this.inboxIntelmatchId.map((item) => {
                    if (typeof item === 'object') {
                        return item.inboxIntelContactId.toString();
                    }
                });
                this.contactInboxService.exportToSalesforce(inboxIntelContactIds).pipe(untilDestroyed(this)).subscribe((res) => {
                    if (res['response'] === 'Success.') {
                        this.inboxintelService.getStats();
                    }
                });
            }
            failedContactsArray.forEach((contact) => {
                this.duplicateContactsMatchIds.forEach((contacts) => {
                    if (contact.matchId === contacts.matchId) {
                        const dFailedContact = new FailedContactModel();
                        dFailedContact.contactName = contact.name ? contact.name : this.getByMatchId(contact.matchId, 'name');
                        dFailedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                        dFailedContact.matchId = contact.matchId;
                        this.commonUtilService.removeMatchId(toBeExported, contact);
                        this.duplicateFailedContacts.push(dFailedContact);
                    }
                });

                if (contact.statusCode === 422) {
                    const failedContact = new FailedContactModel();
                    failedContact.contactName = contact.contactName ? contact.contactName : this.getByMatchId(contact.matchId, 'contactName');
                    failedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                    failedContact.matchId = contact.matchId;
                    failedContact.errorMessage = contact.message;
                    this.failedContacts.push(failedContact);
                    this.commonUtilService.removeMatchId(toBeExported, contact);
                } else if (contact.statusCode === 409) {
                    const failedContact = new FailedContactModel();
                    failedContact.contactName = contact.contactName ? contact.contactName : this.getByMatchId(contact.matchId, 'contactName');
                    failedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                    failedContact.matchId = contact.matchId;
                    failedContact['contactFailureCount'] = contact.contactFailureCount;
                    failedContact.errorMessage = contact.message;
                    this.failedAccounts.push(failedContact);
                }
            });

            this.contactFailureCounts = sumBy(this.failedAccounts, 'contactFailureCount');
            this.isBusy = false;
            this.next();
            if (toBeExported.length > 0) {
                this.requestBodyService.changeRevealMatchesID({ 'type': 'salesforce', 'data': toBeExported });
            }

        }, (error) => {
            if (error.error && error.error.message && error.error.message.length > 0) {
                this.exportError = error.error.message;
                this.showRetryButton = true;
            } else {
                this.exportError = this.commonUtilService.setRevealError(error.status, error.message);
            }

            this.onExportFailed();
        });
    }

    private exportSyncV2() {
        let toBeExported = [];
        if (this.exportFrom === 'fromInboxIntel') {
            this.contacts.forEach((contact) => {
                if (contact.matchId) {
                    toBeExported.push({
                        id: contact.matchId,
                        accountId: contact.accountId,
                        accountCreate: contact.createCompany
                    });
                }
            });
        } else {
            toBeExported = this.contacts.map((contact) => {
                return {
                    id: contact.matchId,
                    accountId: contact.accountId,
                    accountCreate: contact.createCompany
                };
            });
        }
        // Skip all duplicates
        if (this.duplicateResolution === 'skip') {
            if (typeof this.duplicateMatchIds === 'object') {
                for (const key in this.duplicateLeadsMatchIds) {
                    if (this.duplicateLeadsMatchIds.hasOwnProperty(key)) {
                        const indx = toBeExported.findIndex((contact) => contact.id == this.duplicateLeadsMatchIds[key].match_id);
                        if (indx != -1) {
                            toBeExported.splice(indx, 1);
                        }
                    }
                }
                for (const key in this.duplicateContactsMatchIds) {
                    if (this.duplicateContactsMatchIds.hasOwnProperty(key)) {
                        const indx = toBeExported.findIndex((contact) => contact.id == this.duplicateContactsMatchIds[key].match_id);
                        if (indx != -1) {
                            toBeExported.splice(indx, 1);
                        }
                    }
                }
            } else {
                this.duplicateMatchIds.forEach((item) => {
                    const indx = toBeExported.findIndex((contact) => contact.id == item.key);
                    if (indx != -1) {
                        toBeExported.splice(indx, 1);
                    }
                });
            }
        }
        if (toBeExported.length === 0) {
            this.isBusy = false;
            this.currentPageIndex = this.getPageIndex(PageTypes.EXPORT_EMPTY);
            this.executeCurrentStep();
            return;
        }
        //return false;
        this.busyLabel = '';
        this.busySublabel = 'Exporting your data, this will take just a minute...';
        this.isBusy = true;
        this.exportedContactCount = toBeExported.length;
        this.exportV2(this.exportType, this.selectedLeadOwner, this.selectedCampaignIds, this.duplicateResolution, toBeExported, this.icpIntelJobUUID).pipe(untilDestroyed(this)).subscribe((failedContactsArray: any) => {
            if (this.exportFrom === 'fromInboxIntel') {
                const inboxIntelContactIds = this.inboxIntelmatchId.map((item) => {
                    if (typeof item === 'object') {
                        return item.inboxIntelContactId.toString();
                    }
                });
                this.contactInboxService.exportToSalesforce(inboxIntelContactIds).subscribe((res) => {
                    if (res['response'] === 'Success.') {
                        this.inboxintelService.getStats();
                    }
                });
            }
            failedContactsArray.forEach((contact) => {
                this.duplicateContactsMatchIds.forEach((contacts) => {
                    if (contact.matchId === contacts.matchId) {
                        const dFailedContact = new FailedContactModel();
                        dFailedContact.contactName = contact.name ? contact.name : this.getByMatchId(contact.matchId, 'name');
                        dFailedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                        dFailedContact.matchId = contact.matchId;
                        const indx = toBeExported.findIndex((contact) => contact.id == contact.matchId);
                        if (indx != -1) {
                            toBeExported.splice(indx, 1);
                        }
                        this.duplicateFailedContacts.push(dFailedContact);
                    }
                });

                if (contact.statusCode === 422) {
                    const failedContact = new FailedContactModel();
                    failedContact.contactName = contact.contactName ? contact.contactName : this.getByMatchId(contact.matchId, 'contactName');
                    failedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                    failedContact.matchId = contact.matchId;
                    failedContact.errorMessage = contact.message;
                    this.failedContacts.push(failedContact);
                    const indx = toBeExported.findIndex((contact) => contact.id == contact.matchId);
                    if (indx != -1) {
                        toBeExported.splice(indx, 1);
                    }
                } else if (contact.statusCode === 409) {
                    const failedContact = new FailedContactModel();
                    failedContact.contactName = contact.contactName ? contact.contactName : this.getByMatchId(contact.matchId, 'contactName');
                    failedContact.companyName = contact.companyName ? contact.companyName : this.getByMatchId(contact.matchId, 'companyName');
                    failedContact.matchId = contact.matchId;
                    failedContact['contactFailureCount'] = contact.contactFailureCount;
                    failedContact.errorMessage = contact.message;
                    this.failedAccounts.push(failedContact);
                }
            });

            this.contactFailureCounts = sumBy(this.failedAccounts, 'contactFailureCount');
            this.isBusy = false;
            this.next();
            if (toBeExported.length > 0) {
                const matchIds = toBeExported.map((contact) => contact.id);
                this.requestBodyService.changeRevealMatchesID({ 'type': 'salesforce', 'data': matchIds });
            }

        }, (error) => {
            if (error.error && error.error.message && error.error.message.length > 0) {
                this.exportError = error.error.message;
                this.showRetryButton = true;
            } else {
                this.exportError = this.commonUtilService.setRevealError(error.status, error.message);
            }

            this.onExportFailed();
        });
    }

    retryExport() {
        this.currentPageIndex = this.getPageIndex(PageTypes.EXPORT);
        this.executeCurrentStep();
    }

    requestVerification(nonRequestedContacts: any[], unmatchedContacts: any[]): void {
        if (this.commonUtilService.hasRODCreditsRemaining) {
            let selectedMatchIds;
            let selectedUnMatchIds;
            let contactInfo = { verified: null };
            if (nonRequestedContacts || unmatchedContacts) {
                selectedMatchIds = nonRequestedContacts;
                selectedUnMatchIds = unmatchedContacts;
            }
            const notRequestedMatchIds = [];
            const notRequestedUnMatchIds = [];
            selectedMatchIds.forEach((matchId: any) => {
                const requestedData = this.contactService.getRequestResearchData().find((contactData) => contactData.id === matchId);
                if (!requestedData) {
                    notRequestedMatchIds.push(matchId);
                }
            });
            selectedUnMatchIds.forEach((matchId: any) => {
                const requestedData = this.contactService.getRequestResearchData().find((contactData) => contactData.id === matchId);
                if (!requestedData) {
                    notRequestedUnMatchIds.push(matchId);
                }
            });
            if (notRequestedMatchIds.length > 0 || notRequestedUnMatchIds.length > 0) {
                this.contactInboxService.resultPage.resultData.forEach(element => {
                    if (element.selectedContact) {
                        element.requestStatus = 'requesting';
                    }
                });
                this.contactService.requestVerify(notRequestedMatchIds, notRequestedUnMatchIds).pipe(untilDestroyed(this)).subscribe((response) => {
                    notRequestedMatchIds.forEach((matchId: any) => {
                        contactInfo = this.contactInboxService.resultPage.resultData.find((contactObj) => contactObj.searchResult.matchId === matchId);
                        if (contactInfo) {
                            contactInfo['tier'] = 1;
                            contactInfo['requestStatus'] = 'requested';
                            this.contactService.updateRequestResearchData(matchId);
                        }
                    });
                    notRequestedUnMatchIds.forEach((matchId: any) => {
                        contactInfo = this.contactInboxService.resultPage.resultData.find((contactObj) => contactObj.inboxIntelContactId === matchId);
                        if (contactInfo) {
                            contactInfo['tier'] = 1;
                            contactInfo['requestStatus'] = 'requested';
                            this.contactService.updateRequestResearchData(matchId);
                        }
                    });
                    this.rodsService.rodRowData.unshift(response);
                    this.rodsService.setRoDs(this.rodsService.rodRowData);
                    this.toastr.success('Requested successfully!');
                    if (this.humanverified.length === 0) {
                        this.onClose();
                    }
                    // const allMVContacts = notRequestedMatchIds.concat(notRequestedUnMatchIds);
                    this.requestBodyService.changeRevealMatchesID({ 'type': 'requestVerification', 'data': notRequestedMatchIds });
                });
            } else {
                this.toastr.warning('You already requested selected contacts.');
                if (this.humanverified.length === 0) {
                    this.onClose();
                }
            }
        } else {
            this.commonUtilService.displayExhaustedRodMessage();
            this.onClose();
        }
    }

    toggleSelectAll() {
        if (this.isSelected()) {
            this.getFilteredContacts().forEach(val => { val.selectedContact = false });
        } else {
            this.getFilteredContacts().forEach((val) => {
                if (val.matchId) {
                    val.selectedContact = true;
                }
            });
        }
        this.checkIfAllSelected();
    }

    checkIfAllSelected() {
        this.isSelectedAll = this.isSelected();
    }

    private isSelected() {
        const contacts = this.getFilteredContacts().filter((item: any) => item.matchId);
        if (contacts.length) {
            return contacts.every((item: any) => item.selectedContact == true);
        } else {
            return false;
        }
    }

    getSelectdContact() {
        return this.getFilteredContacts().filter(val => val.selectedContact);
    }

    private getFilteredContacts(): Array<any> {
        // added this pipe of transform record and uncheck checkbox when not appear in list
        return this.salesForceAccountMappingPipe.transform(this.contacts, this.filterAccountMapping);
    }

    onChangeAccountFilter() {
        /* const filteredContacts = this.getFilteredContacts();
        if (filteredContacts.length) {
            this.contacts.forEach((contact) => {
                const isRecordVisible = filteredContacts.find((data) => data.matchId == contact.matchId);
                if (!isRecordVisible) {
                    contact.selectedContact = false;
                }
            });
        } else {
           this.contacts.forEach((contact) => { contact.selectedContact = false; });
        } */
        this.checkIfAllSelected();
    }

    onSelectAccount(contact) {
        let selectedContacts = [];
        let isSelectAccount = false;
        if (contact) {
            selectedContacts = [contact];
            isSelectAccount = true;
        } else {
            selectedContacts = this.getSelectdContact();
        }
        const modalConfig: MatDialogConfig = {
            panelClass: 'modal-lg',
            data: {
                contacts: selectedContacts,
                leadOwners: this.leadOwners,
                isSelectAccount: isSelectAccount
            }
        };
        this.matDialog.open(SalesForceAccountListComponent, modalConfig).afterClosed().pipe(untilDestroyed(this)).subscribe((res) => {
            if (res && res.success) {
                selectedContacts.forEach((element) => {
                    const indx = this.contacts.findIndex((contactData) => contactData.matchId === element.matchId);
                    if (indx !== -1) {
                        this.contacts[indx].accountId = res.account.id;
                        this.contacts[indx].accountName = res.account.name;
                        this.contacts[indx].createCompany = false;
                        this.contacts[indx].ownerName = res.account.ownerName;
                    }
                });
                this.contacts.forEach((val) => { val.selectedContact = false });
                this.checkIfAllSelected();
            }
        });
    }

    getSalesForceAccounts() {
        let requestBodyCompany = [];

        this.isLoadingAccountMapping = true;
        try {
            //default create company is true
            this.contacts.forEach((contact) => {
                contact.accountId = '';
                if (this.generalSettings.sfCreateNewAccounts) {
                    contact.createCompany = true;
                } else {
                    contact.createCompany = false;
                }

                if (contact.primaryDomain) {
                    if (requestBodyCompany.findIndex((data) => data.domain == contact.primaryDomain) == -1) {
                        requestBodyCompany.push({
                            "domain": contact.primaryDomain,
                            "name": contact.companyName
                        });
                    }
                }
            });
            const requestBody = {
                companies: requestBodyCompany
            }
            this.salesforceApiService.getAccounts(requestBody).pipe(untilDestroyed(this)).subscribe((res: any) => {
                this.isLoadingAccountMapping = false;
                if (res.results) {
                    this.contacts.forEach((contact) => {
                        let accounts = res.results.filter((element: any) => this.commonUtilService.extractRootDomain(element.website) == this.commonUtilService.extractRootDomain(contact.primaryDomain) || element.name == contact.companyName);
                        /* if (accounts.length == 0) {
                            accounts = res.results.filter((element: any) => element.name == contact.companyName);
                        } */
                        if (accounts.length == 1) {
                            contact.accountId = accounts[0].id;
                            contact.accountName = accounts[0].name;
                            contact.createCompany = false;
                            contact.accountTotal = 1;
                            const leadOwner = this.leadOwners.find((leadOwner) => leadOwner.id == accounts[0].owner_id);
                            if (leadOwner) {
                                contact.ownerName = leadOwner.name;
                            }
                        }
                        if (accounts.length == 0) {
                            contact.accountTotal = 0;
                            if (this.generalSettings.sfCreateNewAccounts) {
                                contact.createCompany = true;
                            } else {
                                contact.createCompany = false;
                            }
                        }
                        if (accounts.length > 1) {
                            contact.accountTotal = accounts.length;
                            contact.createCompany = false;
                        }
                    });
                }
            }, (error) => {
                this.isLoadingAccountMapping = false;
            });
        } catch (error) {
            this.isLoadingAccountMapping = false;
        }
    }

    isNextDisabled() {
        let returnValue = false;
        if (this.currentPageIndex == this.getPageIndex(PageTypes.ACCOUNT_MAPPING)) {
            if (this.generalSettings.sfAllowExportAsContact && this.generalSettings.sfAccountMapping && this.exportType == "contact") {
                const contacts = this.contacts.filter((contact) => contact.accountTotal > 1);
                this.contacts.forEach((contact) => {
                    if (contact.accountTotal > 1 && !contact.accountId) {
                        returnValue = true;
                    }
                });
            }
        }
        return returnValue;
    }

    clearAccount(matchId) {
        const index = this.contacts.findIndex((contactData) => contactData.matchId == matchId);
        if (index != -1) {
            this.contacts[index].accountId = '';
            this.contacts[index].accountName = '';
            this.contacts[index].ownerName = '';
            if (this.generalSettings.sfCreateNewAccounts) {
                if (this.contacts[index].accountTotal > 1) {
                    this.contacts[index].createCompany = false;
                } else {
                    this.contacts[index].createCompany = true;
                }
            } else {
                this.contacts[index].createCompany = false;
            }
        }
    }

    private exportV2(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID: string) {
        return this.featureFlagService.getFlag(FeatureFlagsEnum.WebsocketsSf).pipe(
          take(1),
          switchMap((enabled: boolean) => {
              /*
              if (enabled) {
                  const payload = {
                      duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
                      exportType,
                      leadOwner,
                      campaigns,
                      ids,
                  };

                  return this.socketExportService.export('salesforceContactsExport' , payload);
              }
               */

              return this.salesforceApiService.exportV2(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID);
          })
        )
    }

    private exportV1(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID: string) {
        return this.featureFlagService.getFlag(FeatureFlagsEnum.WebsocketsSf).pipe(
          take(1),
          switchMap((enabled: boolean) => {
              /*
              if (enabled) {
                  const payload = {
                      duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
                      exportType,
                      leadOwner,
                      campaigns,
                      ids,
                  };

                  return this.socketExportService.export('salesforceContactsExport' , payload);
              }
              */

              return this.salesforceApiService.export(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID);
          })
        )
    }

    private getPageIndex(pageType: PageTypes): number {
        return this.pages.findIndex(({ type }) => type === pageType);
    }

    private onExportFailed(): void {
        this.currentPageIndex = this.getPageIndex(PageTypes.EXPORT_FAILED);
        this.showNextButton = false;
        this.showPreviousButton = false;
        this.isBusy = false;
    }
}
